/**
 * formatEtd — Convert raw ETD string dari provider menjadi label readable.
 *
 * Provider Jubelio kadang return ETD dalam format:
 *  - "1-3" / "1 - 3" / "1-3 hari"        → "1 - 3 hari"
 *  - "2 jam"                              → "2 jam"
 *  - ISO range: "2026-06-30T03:29Z-2026-06-30T04:29Z" → diff jam/hari
 *  - "<ISO>-<ISO>" (single ISO with dash) → ambil diff
 *  - Empty / unparseable                  → ""  (caller harus sembunyikan)
 *
 * Customer tidak boleh melihat raw ISO string.
 */

const ISO_RE = /^\d{4}-\d{2}-\d{2}T/;

function tryParseISORange(s) {
  const m = String(s).match(
    /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?Z?)\s*-\s*(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?Z?)/,
  );
  if (!m) return null;
  const a = new Date(m[1]);
  const b = new Date(m[2]);
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return null;
  // Use absolute diff antara b dan a (estimasi durasi pengiriman),
  // bukan diff terhadap now() — itu lebih robust untuk berbagai timezone server.
  const diffMs = Math.abs(b.getTime() - a.getTime());
  if (diffMs <= 0) return null;
  const diffHours = Math.round(diffMs / 3_600_000);
  if (diffHours > 24 * 14) return null;
  // Heuristik: kalau a juga sama hari & range <= 6 jam → tampilkan jam range
  if (diffHours <= 24) {
    if (diffHours <= 1) return "1 jam";
    return `1 - ${diffHours} jam`;
  }
  const diffDays = Math.round(diffHours / 24);
  if (diffDays <= 1) return "1 hari";
  return `1 - ${diffDays} hari`;
}

export function formatEtd(raw) {
  if (!raw) return "";
  const s = String(raw).trim();
  if (!s) return "";
  // Single ISO timestamp (no range) — sembunyikan, jelek
  if (ISO_RE.test(s) && !s.includes("-2") && !s.includes("- 2")) return "";
  // Coba parse ISO range terlebih dahulu
  const iso = tryParseISORange(s);
  if (iso) return iso;
  // Kalau ada banyak digit timestamp tanpa range yang valid, jangan tampilkan
  if (/\d{4}-\d{2}-\d{2}T/.test(s)) {
    // Ada ISO tapi tidak parseable → sembunyikan
    return "";
  }
  // "1-3 hari", "2 jam", dst → tampilkan apa adanya (dengan sedikit cleanup)
  return s.replace(/\s*-\s*/g, " - ");
}
